var _style, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgTires = function SvgTires(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.6 512.6",
    style: {
      enableBackground: "new 0 0 512.6 512.6"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#00000000;}\n\t.st1{fill:current}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 256,
    cy: 255.2,
    r: 252
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M291.2,220.3c-1.6,24.7,3.8,21.8,3.2,30.3c4.8-83.8,37.5-121.3,45.5-130.8c8-9.6,32.7-20.7,56.6-4 C420.4,132.6,438,188.4,438,253s-19.9,121.3-40.7,142.8c-10.2,10.6-26.9,26.4-63.8,26.3c-33.6-0.1-87.8-7.2-113.3-23.9 c-16.1-10.6-47.1-51.9-50.3-133.2c-3.2-81.4,35.1-134,60.6-153.2S320.6,96.6,358.9,99C300.8,118.2,292.2,205.8,291.2,220.3 L291.2,220.3z M368.2,144.8c-29.1-1.1-54.6,49.7-57.1,113.5s19.1,116.5,48.1,117.6s54.6-49.7,57.1-113.5 C418.7,198.6,397.2,146,368.2,144.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M405.7,262.3c-2.4,57.7-24.3,103.6-48.9,102.5c-12.8-0.5-23.8-13.8-31.1-34.5c-1.4-3.9-3.7-12.4-3.7-12.4 s7.5-21.8,10.7-58.5s-8.5-50.2-8.5-50.2s3.6-12,5.8-17.3c9.1-22.5,22-36.5,35.7-35.9C390.2,157,408.1,204.6,405.7,262.3 L405.7,262.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M222.6,103c-42.3-1.6-83-1.6-110.1,12c-18.3,9.2-56.6,48.7-56.6,121.2S62.3,343.9,94.2,371 s109.3,25.6,109.3,25.6s-55-18.4-55-152.4C148.4,138.1,222.6,103,222.6,103L222.6,103z"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTires, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tires.e58d2063.svg";
export { ForwardRef as ReactComponent };